import { render } from "./LoginFormTwoFactorStep.vue?vue&type=template&id=56e03fb1"
import script from "./LoginFormTwoFactorStep.vue?vue&type=script&lang=js"
export * from "./LoginFormTwoFactorStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__